import { Directive, effect, EffectRef, inject, OnDestroy, TemplateRef, ViewContainerRef } from "@angular/core";

import { AuthService } from "@core/services/auth.service";
import { User } from "@shared/models/user.model";

@Directive()
export abstract class BaseAuthorizationDirective implements OnDestroy {
  protected _hasView = false;
  private _effectRef?: EffectRef;

  protected readonly _authService = inject(AuthService);
  protected readonly _templateRef = inject(TemplateRef<unknown>);
  protected readonly _viewContainer = inject(ViewContainerRef);

  constructor() {
    this._effectRef = effect(() => {
      const user = this._authService.currentUser();
      this.updateView(user);
    });
  }

  ngOnDestroy(): void {
    if (this._effectRef) {
      this._effectRef.destroy();
    }
  }

  protected abstract checkAuthorization(user: User): boolean;

  protected updateView(user?: User | null): void {
    if (user === undefined) {
      user = this._authService.currentUser();
    }

    if (!user) {
      this._viewContainer.clear();
      this._hasView = false;
      return;
    }

    const isAuthorized = this.checkAuthorization(user);

    if (isAuthorized && !this._hasView) {
      this._viewContainer.createEmbeddedView(this._templateRef);
      this._hasView = true;
    } else if (!isAuthorized && this._hasView) {
      this._viewContainer.clear();
      this._hasView = false;
    }
  }
}
